import { SortOrder } from '@tencent/memoire-core';
import { KeyUtils } from '.';
import { IOrderType, ClientQueryConditionType, } from '../client-msg.interface';
var QueryConditionBuilder = /** @class */ (function () {
    function QueryConditionBuilder() {
        this.conditions = [];
        this.limitCount = Number.MAX_VALUE;
        this.offsetCount = 0;
        this.orders = [];
    }
    QueryConditionBuilder.prototype.addKeyQueryCondition = function (keyPath, query) {
        var _this = this;
        // not union key
        if (typeof keyPath === 'string') {
            return this.addCondition(keyPath, query);
        }
        // not range query, user union join key to query
        if (query instanceof Array) {
            return this.addCondition(KeyUtils.getDBKeyFromKeyPath(keyPath), KeyUtils.normalizeUnionKeyValue(query));
        }
        if (!(query instanceof IDBKeyRange)) {
            throw new Error("unsupported key: " + query);
        }
        var upper = query.upper, upperOpen = query.upperOpen, lower = query.lower, lowerOpen = query.lowerOpen;
        // split array to single key query condition
        keyPath.forEach(function (key, index) {
            var lowerValue = lower === null || lower === void 0 ? void 0 : lower[index];
            var upperValue = upper === null || upper === void 0 ? void 0 : upper[index];
            if (lowerValue === undefined && upperValue === undefined) {
                throw new Error("key range query param has error, keyPath: " + keyPath + " lower: " + lower + ", upper: " + upper);
            }
            if (lowerValue !== undefined && upperValue !== undefined) {
                _this.addCondition(key, IDBKeyRange.bound(lowerValue, upperValue, lowerOpen, upperOpen));
            }
            else if (lowerValue !== undefined) {
                _this.addCondition(key, IDBKeyRange.lowerBound(lowerValue, lowerOpen));
            }
            else {
                _this.addCondition(key, IDBKeyRange.upperBound(upperValue, upperOpen));
            }
        });
        return this;
    };
    QueryConditionBuilder.prototype.addCondition = function (column, query, conditionType) {
        if (conditionType === void 0) { conditionType = ClientQueryConditionType.ONLY; }
        var type = conditionType;
        var value;
        // client range type is not match IDBKeyRange, so we need to convert it
        if (query instanceof IDBKeyRange) {
            if (query.lower !== undefined && query.upper !== undefined) {
                type = ClientQueryConditionType.BOUND;
                value = { lower: query.lower, upper: query.upper, lowerOpen: query.lowerOpen, upperOpen: query.upperOpen };
            }
            else if (query.lower !== undefined) {
                type = ClientQueryConditionType.LOWER_BOUND;
                value = { lower: query.lower, open: query.lowerOpen };
            }
            else {
                type = ClientQueryConditionType.UPPER_BOUND;
                value = { upper: query.upper, open: query.upperOpen };
            }
        }
        else {
            value = query;
        }
        this.conditions.push({ type: type, column: column, value: value });
        return this;
    };
    QueryConditionBuilder.prototype.setLimit = function (count) {
        this.limitCount = count;
        return this;
    };
    QueryConditionBuilder.prototype.setOffset = function (count) {
        this.offsetCount = count;
        return this;
    };
    QueryConditionBuilder.prototype.addOrder = function (key, orderType) {
        var type = IOrderType.INCREASE;
        if (orderType === SortOrder.DESCENDING) {
            type = IOrderType.DECREASE;
        }
        this.orders.push({
            key: key,
            type: type,
        });
    };
    QueryConditionBuilder.prototype.build = function () {
        return {
            _conditions: this.conditions,
            _limitCount: this.limitCount,
            _offsetCount: this.offsetCount,
            _orders: this.orders,
        };
    };
    return QueryConditionBuilder;
}());
export { QueryConditionBuilder };
//# sourceMappingURL=query-condition-builder.js.map